export { default as AppMain } from './AppMain';
export { default as Settings } from './Settings/index';
export { default as Sidebar } from './Sidebar/index';
export { default as Navbar } from './Navbar'; // export { default as TagsView } from './TagsView/index.vue'